import { render } from "./RaportSvg.vue?vue&type=template&id=2dc4234d"
import script from "./RaportSvg.vue?vue&type=script&lang=js"
export * from "./RaportSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__